// components/Common/FileViewerModal.jsx

import { useMemo } from "react";
import PdfViewerModal from "./PdfViewerModal/PdfViewerModal";
import ImageViewer from "./ImageViewer/ImageViewer";

const resolveFileUrl = fileUrl => {
  if (!fileUrl) return ""

  if (/^(blob:|data:)/i.test(fileUrl)) {
    return fileUrl
  }

  const apiBaseUrl = process.env.REACT_APP_API || ""

  try {
    const appBaseUrl = apiBaseUrl
      ? apiBaseUrl.replace(/\/api\/?$/i, "")
      : window.location.origin
    const parsedUrl = new URL(fileUrl, `${appBaseUrl}/`)

    if (parsedUrl.pathname.startsWith("/storage/")) {
      return new URL(parsedUrl.pathname + parsedUrl.search, `${appBaseUrl}/`)
        .toString()
    }

    return parsedUrl.toString()
  } catch {
    return fileUrl
  }
}

const FileViewerModal = ({
  isOpen = false,
  onClose = () => {},
  fileUrl = "",
  fileName = "Document",
}) => {
  const resolvedFileUrl = useMemo(() => resolveFileUrl(fileUrl), [fileUrl])
  const isPdf = useMemo(() => {
    if (!resolvedFileUrl) return false
    return (
      resolvedFileUrl.toLowerCase().endsWith(".pdf") ||
      fileName.toLowerCase().endsWith(".pdf")
    )
  }, [fileName, resolvedFileUrl])

  if (!isOpen || !resolvedFileUrl) return null

  return isPdf ? (
    <PdfViewerModal
      isOpen={isOpen}
      onClose={onClose}
      pdfUrl={resolvedFileUrl}
      fileName={fileName}
    />
  ) : (
    <ImageViewer
      isOpen={isOpen}
      onClose={onClose}
      images={[resolvedFileUrl]}
      title={fileName}
    />
  )
}

export default FileViewerModal
